module.exports = __webpack_public_path__ + "static/img/2.360ef3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/2.png
// module id = 6aaQ
// module chunks = 0